import axios from 'axios';
export const getOrganizationActivityMetrics = async (activityMetricApiRoot, organizationId, dateRange, accessToken) => axios
    .get(`${activityMetricApiRoot}/organization/${organizationId}`, {
    params: {
        dateFrom: dateRange.from.getTime(),
        dateTo: dateRange.to.getTime(),
    },
    headers: {
        Authorization: accessToken.value(),
    },
})
    .then((output) => output.data);
export const trackEvent = async (activityMetricApiRoot, event) => axios.post(`${activityMetricApiRoot}/track`, event).then((output) => output.status === 201);
export const getPageActivityMetrics = async (activityMetricApiRoot, pageId, dateFrom, dateTo, accessToken) => axios
    .get(`${activityMetricApiRoot}/page/${pageId}`, {
    params: {
        dateFrom: dateFrom,
        dateTo: dateTo,
    },
    headers: {
        Authorization: accessToken.value(),
    },
})
    .then((output) => output.data);
export var TrackCategory;
(function (TrackCategory) {
    TrackCategory["CERTIFICATE"] = "CERTIFICATE";
    TrackCategory["PAGE"] = "PAGE";
})(TrackCategory || (TrackCategory = {}));
export var CertificateTrackAction;
(function (CertificateTrackAction) {
    CertificateTrackAction["DOWNLOAD_IMAGE"] = "DOWNLOAD_IMAGE";
    CertificateTrackAction["DOWNLOAD_EDCI"] = "DOWNLOAD_EDCI";
    CertificateTrackAction["VIEW"] = "VIEW";
    CertificateTrackAction["VERIFY"] = "VERIFY";
    CertificateTrackAction["ADD_TO_LINKEDIN_PROFILE"] = "ADD_TO_LINKEDIN_PROFILE";
})(CertificateTrackAction || (CertificateTrackAction = {}));
export var PageTrackAction;
(function (PageTrackAction) {
    PageTrackAction["AD_CLICK"] = "AD_CLICK";
    PageTrackAction["LEAD"] = "LEAD";
})(PageTrackAction || (PageTrackAction = {}));
//# sourceMappingURL=index.js.map